import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast, Zoom } from "react-toastify";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import {  useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Stripe from "stripe";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./checkoutDelay";
import authHeader from "../../../services/auth-header";
import SpinnerComponent from "../../../components/Loder/spinner";
import { API,STRIPEPUBLICKEY,STRIPESECRETKEY } from "../../../backend";
import Helper from "../../../Helper";

const SignupDelay = () => {
  const [clientSecret, setClientSecret] = useState("");
  const stripePromise = loadStripe(STRIPEPUBLICKEY);
  const options = { clientSecret };
  const stripe = Stripe(STRIPESECRETKEY);
  let navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, trigger } = useForm();
  const form = useRef();
  const checkBtn = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [company_name, setCompnayName] = useState("");
  const [address, setAddress] = useState("");
  const [country_name, setCountry] = useState([]);
  const [state_name, setState] = useState([]);
  const [city, setCity] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [userAllow, setUserAllow] = useState("1");
  const [country, setCountryid] = useState("");
  const [state, setStateid] = useState("");
  const [elements, setElements] = useState(null);

  const [plan, setPlan] = useState("");
  const [companydata, setCompanydata] = useState([]);
  const [companyid, setCompanyid] = useState("");
  const [transactonid, setTransactonidid] = useState("");
  const [userid, setUserid] = useState("");
  const [amount, setAmount] = useState(1200);
  const [paymentintent, setPaymentIntent] = useState('');
  const [paymentintentid, setPaymentIntentID] = useState('');
  const [userdata, setUserData] = useState(false)
  const [updatestripeintent, setUpdatestripeintent] = useState(false)
  const [planData, setplanData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [start_date, setStart_date] = useState('')
  const [end_date, setEnd_date] = useState('')
  const fetchCalled = useRef(false);

  const generatePassword = () => {
    const uppercaseLetter = String.fromCharCode(
      65 + Math.floor(Math.random() * 26)
    ); 
    const lowercaseLetters = Array.from({ length: 2 }, () =>
      String.fromCharCode(97 + Math.floor(Math.random() * 26))
    ).join(""); 
    const digits = Math.floor(100 + Math.random() * 900); 

    const newPassword = uppercaseLetter + lowercaseLetters + "@" + digits;
    setPassword(newPassword);
  };

  useEffect(() => {
    generatePassword();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const valueofpayment_intent_client_secret = searchParams.get(
      "payment_intent_client_secret"
    );
    setPaymentIntent(valueofpayment_intent_client_secret);
    const param1Value = searchParams.get('plan');
    setPlan(param1Value)
  }, []);

  useEffect(() => {
    const currentDate = new Date(); 

    const futureEndDate = new Date(currentDate); 
    futureEndDate.setFullYear(currentDate.getFullYear() + 1);

    const startDate = Helper.DatePicker(currentDate);
    const endDate = Helper.DatePicker(futureEndDate);

    setStart_date(startDate); 
    setEnd_date(endDate); 
  }, []);

  const getPlan = async () => {
    setLoading(true)
    await axios.get(API + "company/planpackages/", { params: { name: plan } }, {
      headers: authHeader()
    }).then((res) => {
      if (res.data.success === 1) {
        const amounts = res.data.response.year_price * 12
        const plans = res.data.response.name
        setplanData(res.data.response)
        setAmount(res.data.response.year_price * 12)
        setUserAllow(res.data.response.number_user)
        setLoading(false)
        fetchClientSecret(amounts, plans)
      }
    })
  }
  useEffect(() => {
    if (plan !== '') {
      getPlan()
    }
  }, [plan])

  useEffect(() => {
    const getcountry = async () => {
      const res = await fetch(API + "helper/ajax/load-countries/");
      const getcon = await res.json();
      setCountry(await getcon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcoutryid = event.target.value;
    setCountryid(getcoutryid);
  };

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid)
  }
  useEffect(() => {
    if (country !== '') {
      const getstate = async () => {
        const resst = await fetch(API + "helper/ajax/load-states/" + country + "/");
        const getst = await resst.json();
        setState(await getst);
      }
      getstate();
    }
  }, [country]);

  useEffect(() => {

  }, [updatestripeintent])

  const fetchClientSecret = async (amounts, plans) => {
    if (!fetchCalled.current) {
      fetchCalled.current = true;
      try {
        const response = await fetch(API + 'accounting/create-payment-intent/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: ['item1', 'item2'],
            amount: amounts,
            plan: plans
          }),
        })
        const dataa = await response.json();
        if (response.ok) {
          axios.post(API + 'accounting/stripecheckout/', {
            email: 'rojibed819@astegol.com',
            intent_id:dataa.intent_id.payment_method_configuration_details.id
          },
          ).then((res) => {
          })
         
        }
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        
        setClientSecret(dataa.clientSecret);
        setPaymentIntentID(dataa.intent_id.id);

  } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  }
};

useEffect(() => {
  if (userAllow > '1') {
    const value = parseInt(parseInt(planData.year_price) * 12) * parseInt(userAllow)
    setAmount(value)
  } else {
    const value2 = parseInt(parseInt(planData.year_price) * 12) * parseInt(userAllow)

    setAmount(value2)
  }
}, [userAllow])


const uservalidation = async () => {
  try {
    const response = await axios.post(API + 'accounting/uservalidation/', {
      email
    }, { headers: authHeader() }).then((response) => {
      if (response.data.success === 1) {
        toast.error(`${response.data.response}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        setEmail("")
      }
      else {
        console.log("ok")

      }
    }
    )
    await trigger()

  } catch (error) {
    console.error("Error fetching client secret:", error);
  }
};
return (
  <div>
    {loading === true && <SpinnerComponent />}
    {isLoading && <SpinnerComponent />}
    <section>
      <ToastContainer autoClose={2000} theme="colored" transition={Zoom} />
      <div className="page-header section-height-70">
        <div className="container" style={{ paddingLeft: 'var(--bs-gutter-x, 1.6rem)', height: 'auto' }}>

          <div className="row" style={{ backgroundColor: 'white', marginTop: '4%', borderRadius: '10px', width: '100%', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <button className="font-weight-bold d-flex"
                style={{ backgroundColor: '#f1e9e9', borderRadius: '5px', border: 'none', fontSize: '10px', width: '70px', justifyContent: 'center', padding: '5px' }}
                onClick={() => navigate('/login')}
              >
                <i class="bi bi-arrow-left"></i>
                &nbsp;&nbsp;Back
              </button>
              <div style={{ flex: "1", textAlign: "center" }}>
                <h4 className="text-info text-gradient">
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/logo.png"}
                    alt="Reimazine"
                    style={{ maxWidth: '160px', maxHeight: '160px', marginTop: '10px' }}
                  />
                </h4>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto mb-4" style={{ marginTop: '-23px' }}>
              <div className="card mt-4" style={{ border: '1px solid #e5e5e5;' }}>
                <div className="card-header pb-0 text-left bg-transparent">
                  <p className="h-1" style={{ fontSize: '22px', color: 'black' }}>{planData.name}</p>{" "}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '15px', color: 'black' }}>Cost</span>
                    <span style={{ display: 'inline-block', color: 'black' }}>
                      <span style={{ fontSize: '20px' }}>
                        ${planData.year_price}
                      </span>
                      <span>/user/month</span>
                    </span>
                  </div>
                  <div className="form-group" style={{ marginTop: '1rem' }}>
                    <div className="d-flex">
                      <span htmlFor="user" style={{ minWidth: '150px', marginRight: '10px', fontSize: '15px', color: 'black' }}>
                        Enter Number of Users
                      </span>
                      <input
                        type="number"
                        min='1'
                        value={userAllow}
                        className="form-control small-input"
                        placeholder="No of user"
                        name="userAllow"
                        onChange={(e) => {
                          const newValue = Math.max(1, parseInt(e.target.value, 10)) || '';
                          setUserAllow(newValue);
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '-2rem' }}>
                    <span style={{ fontSize: '15px', color: 'black' }}>Total Cost per year</span>
                    <span style={{ display: 'inline-block', color: 'black' }}>
                      <span style={{ fontSize: '20px' }}>
                        ${amount ? amount : 0}
                      </span>
                    </span>
                  </div>

                  <ul className="mb-5 list-unstyled text-muted">
                    {" "}
                  </ul>{" "}

                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-5 col-md-6 d-flex flex-column mx-auto" style={{ marginTop: '-23px' }}>
              <div className="card mt-4 mb-8">
                <div className="card-body">
                  <><Form role="form text-left"
                    ref={form}
                    action="."
                    method="POST"
                    id="companyForm">
                    {(
                      <div className="center red-text">
                        <div className="form-group d-flex">
                          <div className="flex-grow-1 me-3">
                            <label htmlFor="companyname">Company Name</label>
                            <input
                              type="text"
                              name="company_name"
                              value={company_name}
                              className="form-control"
                              placeholder="Company Name"
                              {...register("company_name", {
                                onChange: (e) => {
                                  trigger();
                                  setCompnayName(e.target.value);
                                },
                                required: true,
                              })} />
                            <div className="invalid-feedback">
                              {errors.company_name?.type === "required" && "Company name is required"}
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <label htmlFor="name">Name</label>
                            <input
                              type="text"
                              name="name"
                              value={name}
                              className="form-control"
                              placeholder="Name"
                              {...register("name", {
                                onChange: (e) => {
                                  trigger();
                                  setName(e.target.value);
                                },
                                required: true,
                              })} />
                            <div className="invalid-feedback">
                              {errors.name?.type === "required" && "Name is required"}
                            </div>
                          </div>
                        </div>
                        <div className="form-group d-flex">
                          <div className="flex-grow-1 me-3">
                            <label htmlFor="email">Email</label>
                            <input
                              type="email"
                              value={email}
                              className="form-control"
                              placeholder="Email"
                              name="email"
                              {...register("email", {
                                onChange: (e) => {
                                  trigger();
                                  setEmail(e.target.value);
                                },
                                onBlur: (e) => { uservalidation(); },

                                required: 'Enter valid Email',
                                pattern: {
                                  value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                  message: 'Please enter a valid email',
                                },
                              })} />
                            <div className="invalid-feedback">{errors.email && errors.email?.message}</div>
                          </div>
                          <div className="flex-grow-1">
                            <label htmlFor="phonenumber">Phone Number</label>
                            <input
                              type="text"
                              name="phone_number"
                              value={phone_number}
                              className="form-control"
                              placeholder="Phone Number"
                              {...register("phone_number", {
                                onChange: (e) => {
                                  trigger();
                                  setPhoneNumber(e.target.value);
                                },
                                required: true,
                              })} />
                            <div className="invalid-feedback">
                              {errors.phone_number?.type === 'required' && 'Phone Number is required'}
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="address">Address</label>
                          <input
                            type="text"
                            name="address"
                            value={address}
                            className="form-control"
                            placeholder="Address"
                            {...register("address", {
                              onChange: (e) => {
                                trigger();
                                setAddress(e.target.value);
                              }, required: true
                            })} />
                          <div className="invalid-feedback">

                            {errors.address?.type === 'required' && "Address is required"}
                          </div>
                        </div>
                        <div className="form-group d-flex flex-wrap">
                          <div className="flex-grow-1 me-3 mb-3">
                            <label htmlFor="country">Country</label>
                            <select
                              type="text"
                              name="country_name"
                              className="form-control"
                              {...register("country", {
                                onChange: (e) => {
                                  trigger();
                                  handlecountry(e);
                                }, required: true
                              })}
                            >
                              <option value=''>---Select Country---</option>
                              {country_name.map((countryget) => (
                                <option key={countryget.id} value={countryget.id}>{countryget.name}</option>
                              ))}
                            </select>
                            <div className="invalid-feedback">{errors.country?.type === 'required' && 'Country is required'}</div>
                          </div>
                          <div className="flex-grow-1 me-3 mb-3">
                            <label htmlFor="state">State</label>
                            <select
                              name="state"
                              className="form-control"
                              {...register("state", {
                                onChange: (e) => {
                                  trigger();
                                  handlestate(e);
                                }, required: true
                              })}
                            >
                              <option value=''>---Select State---</option>
                              {state_name.map((resst) => (
                                <option key={resst.id} value={resst.id}>{resst.name}</option>
                              ))}
                            </select>
                            <div className="invalid-feedback">{errors.state?.type === 'required' && 'State is required'}</div>
                          </div>
                          <div className="flex-grow-1 me-3 mb-3">
                            <label htmlFor="city">City</label>
                            <input
                              type="text"
                              name="city"
                              value={city}
                              className="form-control"
                              placeholder="City"
                              {...register("city", {
                                onChange: (e) => {
                                  trigger();
                                  setCity(e.target.value);
                                }, required: true
                              })} />
                            <div className="invalid-feedback">{errors.city?.type === 'required' && 'City is required'}</div>
                          </div>

                        </div>
                        <div className="flex-grow-1 mb-3">
                          <label htmlFor="zipcode">Zip Code</label>
                          <input
                            type="text"
                            name="zip_code"
                            value={zip_code}
                            className="form-control"
                            placeholder="Zip Code"
                            {...register("zip_code", {
                              onChange: (e) => {
                                trigger();
                                setZipCode(e.target.value);
                              }, required: true
                            })} />
                          <div className="invalid-feedback">{errors.zip_code?.type === 'required' && 'Zip Code is required'}</div>
                        </div>
                      </div>
                    )}
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form><div className="row card-body">

                      <div id="checkout ">
                        {clientSecret && (
                          <Elements stripe={stripePromise} options={{ clientSecret }}
                          >

                            <CheckoutForm
                              setIsLoading={setIsLoading}
                              isLoading={isLoading}
                              userData={setUserData}
                              updatestripeintent={setUpdatestripeintent}
                              updatestate={updatestripeintent}
                              paymentintentid={paymentintentid}
                              companydata={companydata}
                              companyid={companyid}
                              userid={userid}
                              transactonid={transactonid}
                              company_name={company_name}
                              name={name}
                              email={email}
                              phone_number={phone_number}
                              address={address}
                              country={country}
                              state={state}
                              city={city}
                              zip_code={zip_code}
                              userAllow={userAllow}
                              amount={amount}
                              start_date={start_date}
                              end_date={end_date}
                            />

                          </Elements>
                        )}
                      </div>
                    </div></>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);
};
export default SignupDelay;
